import { useTheme } from "../theme"

export const ConnectedIcon = () => {
  const theme = useTheme()
  const fill = theme.palette.full.green
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.0002 11C22.0002 17.0752 17.0754 22 11.0002 22C4.92498 22 0 17.0752 0 11C0 4.92484 4.92498 9.24983e-07 11.0002 9.24983e-07C17.0754 9.24983e-07 22.0002 4.92484 22.0002 11Z"
        fill={fill}
      />
      <path
        d="M6.12309 14.999L6.12325 14.9992C6.12285 14.9996 6.12247 14.9996 6.12247 14.9996L5.79392 15.3292C5.50196 15.622 5.50196 16.0966 5.79589 16.3897C5.94237 16.5352 6.13373 16.6084 6.32517 16.6084C6.51756 16.6084 6.70992 16.5352 6.8565 16.3877L7.18456 16.0586L7.77735 15.4659L6.71673 14.4053L6.12309 14.999Z"
        fill="white"
      />
      <path
        d="M16.7514 8.14739C16.4604 7.85354 15.9837 7.84953 15.6907 8.14157L13.5802 10.2302L11.936 8.58615L14.0248 6.47551C14.3157 6.18166 14.3139 5.70601 14.0188 5.41497C13.724 5.12393 13.2493 5.12594 12.9583 5.42079L10.8755 7.52562L10.304 6.95396C10.011 6.66112 9.53634 6.66112 9.2435 6.95396L8.15648 8.04095C7.31956 8.878 6.83818 9.97361 6.80108 11.1259C6.76396 12.2969 7.18677 13.3857 7.99346 14.1915C8.76685 14.965 9.80012 15.3867 10.9164 15.3867C10.9633 15.3867 11.011 15.3857 11.0589 15.3837C12.2112 15.3476 13.3068 14.8662 14.1439 14.0293L15.2309 12.9413C15.5237 12.6485 15.5237 12.1738 15.2309 11.8808L14.6408 11.2909L16.7454 9.20792C17.0403 8.91688 17.0423 8.44144 16.7514 8.14739Z"
        fill="white"
      />
    </svg>
  )
}
